<template>
  <section class="delivery-download">
    <v-container class="download-container">
      <v-row align="center" justify="space-between" no-gutters>
        <v-col cols="12" md="8" class="text-col">
          <h2 class="download-text">
            จากครัวชุมชน สู่จานอาหารที่คุณหลงรักช้อปง่าย จ่ายสะดวก โหลดเลย!
          </h2>
        </v-col>

        <v-col cols="12" md="4" class="btn-col d-flex justify-end">
          <div class="qr-wrapper">
            <v-img src="/qr_code.png" alt="QR Code" width="140" height="140" contain class="qr-img" />
            <p class="qr-label">สแกนเพื่อใช้งาน</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "DeliveryDownload",
};
</script>

<style scoped>
.delivery-download {
  background: #b13929;
  padding: 60px 0;
  color: #ffffff;
  font-family: "Noto Sans Thai", system-ui, sans-serif;
  margin-top: 40px;
}
.download-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 64px;
  box-sizing: border-box;
}
.download-text {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.5;
  margin: 0;
}
.qr-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.qr-img {
  border-radius: 8px;
  background: #ffffff;
  padding: 6px;
}
.qr-label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  opacity: 0.9;
}

@media (max-width: 960px) {
  .delivery-download {
    margin-top: 24px;
  }
  .download-container {
    padding: 0 16px;
  }
  .download-text {
    text-align: center;
    font-size: 18px;
    margin-bottom: 16px;
  }
  .btn-col {
    justify-content: center !important;
  }
}
</style>
